import { section } from "@/neon";

import { backgroundVideoHandler } from "@/lib/a11y";
import { animateImageWithText } from "@/lib/animation";

const selectors = {
  video: ".image-with-text__video",
};

section("image-with-text", {
  videoHandler: null,

  onLoad() {
    this.animateImageWithText = animateImageWithText(this.container);
    const videoWrapper = this.container.querySelector(selectors.video);

    if (videoWrapper) {
      this.videoHandler = backgroundVideoHandler(this.container);
    }
  },

  onUnload() {
    this.animateImageWithText?.destroy();
    this.videoHandler && this.videoHandler();
  },
});
